import React from 'react'

import { IEventData } from 'meta/pages/v4/event'
import { ILocationData } from 'meta/pages/v4/location'
import { IUserTicketData } from 'meta/pages/v4/ticket'
import { ITypeTicketData } from 'meta/pages/v4/typeticket'
import { ITypeTicketCollectionData } from 'meta/pages/v4/typeticketcollection'
import { IWalletEvent } from 'meta/pages/v4/wallet'

import { useUserTicketData } from 'hooks/useTicket'
import { useTypeTicketData } from 'hooks/useTypeTicket'
import { useTypeTicketCollectionData } from 'hooks/useTypeTicketCollection'

import TicketCardSkeleton from '../TicketCardSkeleton'
import TicketCard from '.'

type TicketProps = {
  cod: string
  eventData: IEventData
  locationData: ILocationData
  walletEventData: IWalletEvent
  setShowAddExtraBalloon(value: boolean): void
  idx: number
  activeCard: number
  useLongCard: boolean
}

type TypeTicketProps = {
  baseProps: TicketProps
  ticketData: IUserTicketData
}

type TypeTicketCollectionProps = {
  baseProps: TicketProps
  ticketData: IUserTicketData
  typeTicketData: ITypeTicketData
}

export type TicketMobileCardProps = {
  baseProps: TicketProps
  ticketData: IUserTicketData
  typeTicketData: ITypeTicketData
  typeTicketCollectionData?: ITypeTicketCollectionData
}

const TicketCardContainer: React.FC<TicketProps> = (props) => {
  const { cod, useLongCard, idx, activeCard } = props

  const userTicketData = useUserTicketData({ cod })

  if (![idx - 1, idx, idx + 1].includes(activeCard)) {
    return null
  }

  if (!userTicketData) {
    return <TicketCardSkeleton useLongCard={useLongCard} />
  }

  return <TypeTicketContainer baseProps={props} ticketData={userTicketData} />
}

const TypeTicketContainer: React.FC<TypeTicketProps> = (props) => {
  const { ticketData, baseProps } = props

  const { useLongCard } = baseProps

  const typeTicketData = useTypeTicketData({ id: ticketData.typeTicketId })

  if (!typeTicketData) {
    return <TicketCardSkeleton useLongCard={useLongCard} />
  }

  if (typeTicketData && typeTicketData.typeTicketCollection?.id) {
    return (
      <TypeTicketCollectionContainer baseProps={baseProps} ticketData={ticketData} typeTicketData={typeTicketData} />
    )
  } else {
    return <TicketCard baseProps={baseProps} ticketData={ticketData} typeTicketData={typeTicketData} />
  }
}

const TypeTicketCollectionContainer: React.FC<TypeTicketCollectionProps> = (props) => {
  const { ticketData, typeTicketData, baseProps } = props

  const { useLongCard } = baseProps

  const typeTicketCollectionData = useTypeTicketCollectionData({ id: typeTicketData.typeTicketCollection?.id ?? -1 })

  if (!typeTicketCollectionData) {
    return <TicketCardSkeleton useLongCard={useLongCard} />
  }

  return (
    <TicketCard
      baseProps={baseProps}
      ticketData={ticketData}
      typeTicketData={typeTicketData}
      typeTicketCollectionData={typeTicketCollectionData}
    />
  )
}

export default TicketCardContainer
